var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-file-input',_vm._g(_vm._b({},'v-file-input',_vm.computedProps,false),_vm.computedListeners))}
var staticRenderFns = []

export { render, staticRenderFns }